<script lang="ts">
	import type { Contact } from "../../../../core/schema/Contact.js";
	import ContactCard from "./ContactCard.svelte";
	import { nbspify } from "../../../../core/utils/nbspify.js";

	export let contacts: Contact[];
	export let headline: string;
	export let key: string;
</script>

{#if contacts.length > 0}
	<div class="lg:grid-cols-4 xl:grid">
		<div class="lg:p-8">
			<h2
				class="font-spaceGrotesk font-bolder text-2lg rounded-lg p-4 pb-0 leading-[1.1] max-lg:mb-4 md:text-xl lg:p-0 lg:font-normal"
			>
				{nbspify(headline)}
			</h2>
			{#if key === "serviceAndSupport"}
				<div class="p-4 pt-0 max-lg:my-5 lg:p-0">
					<p class="font-spaceGrotesk text-md lg:text-2md text-primary mb-0 block font-bold leading-[1.4]">Hotline</p>
					<!-- TODO hotline phone number -->
					<a
						class="font-spaceGrotesk text-md lg:text-2md text-primary mb-0 block leading-[1.4]"
						href="tel:00420554818300">{nbspify("+420 554 818 300")}</a
					>
					<a
						class="font-spaceGrotesk text-md lg:text-2md text-primary mb-0 block leading-[1.4]"
						href="mailto:support@vertiflex.eu">support@vertiflex.eu</a
					>
				</div>
			{/if}
		</div>
		<div class="col-span-3 grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3">
			{#each contacts as contact}
				<ContactCard {contact} />
			{/each}
		</div>
	</div>
{/if}
